import { useState } from "react";

export default function NavbarCheck() {
  const [burgerMenu, setburgerMenu] = useState(false);
  return (
    <nav class="bg-gray-800 border-gray-200 px-2 sm:px-4 py-2.5 dark:bg-gray-800 sticky top-0 z-50">
      <div class="container flex flex-wrap justify-between items-center mx-auto">
        <a href="/" class="group flex">
          <svg class="z-10 transition ease-in-out delay-150 group-hover:-translate-x-20 duration-300 mr-3 h-16" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3390.61 1053.87"><defs><linearGradient id="a" x1="2002.17" y1="1099.25" x2="3615.3" y2="1099.25" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fab4ff" /><stop offset="1" stop-color="#ffca5f" /></linearGradient></defs><path d="M370.74,580.61H812.21L794,711.72H495.22L457.05,993.86H704.33L687.73,1120H438.79l-69.71,499.55H224.7Zm517.81,0H1091c197.49,0,282.13,53.11,250.6,275.5l-8.3,69.71c-23.23,154.34-74.68,210.77-164.3,237.32l63.07,456.4H1087.71l-61.41-439.8h-78l-61.41,439.8H742.5Zm152.69,476.32c112.85,0,134.43-29.88,151-137.75l8.3-73c14.94-97.91,3.32-139.4-109.53-139.4h-76.35l-49.79,350.18Zm312,267.2,66.38-476.32c26.56-189.19,122.81-275.5,283.8-275.5,224,0,262.22,83,237.33,322L1791.41,905.9c16.6-157.66,21.57-202.47-89.62-202.47-78,0-122.81,41.49-137.75,151l-68,479.63c-16.59,111.2-1.65,164.31,97.92,164.31,102.9,0,117.84-41.49,151-214.09L1886,1310.85c-41.49,210.77-102.9,315.33-295.42,315.33C1388.12,1626.18,1323.39,1528.26,1353.27,1324.13Z" transform="translate(-224.7 -572.31)" /><path d="M2123.32,796.36H2002.17L2032,580.61h370.1l-146,1038.93H2007.15Zm295.4,496.23,56.43-403.29c21.57-156,89.62-317,346.86-317,322,0,340.23,175.93,320.31,328.61l-58.09,406.61c-21.57,156-101.23,318.65-350.18,318.65C2428.68,1626.18,2397.15,1448.6,2418.72,1292.59Zm414.91,19.92,58.09-418.23c11.61-73-3.32-106.21-69.71-106.21s-88,34.85-97.92,107.87L2666,1310.85c-10,74.69,5,106.22,68,106.22C2793.8,1417.07,2823.67,1385.54,2833.63,1312.51Zm502.85-516.15H3215.33l29.87-215.75h370.1L3469.25,1619.54H3220.31Z" transform="translate(-224.7 -572.31)" fill="url(#a)" /></svg>
          <svg class="z-0 absolute transition ease-in-out delay-150 -translate-y-1 h-10 opacity-0 group-hover:opacity-100 group-hover:translate-x-32 duration-300" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 1139.99 169.23"><text transform="matrix(0.99, 0, -0.14, 0.99, 5.29, 131.63)" opacity="0.4" font-size="155" font-family="AvenirNextLTPro-Bold, Avenir Next LT Pro" font-weight="700">B<tspan x="103.5" y="0" letter-spacing="-0.02em">Y </tspan><tspan x="239.07" y="0">TEAM 2976</tspan></text></svg>
        </a>
        <div class="flex md:order-2">
          <a href="/getstarted">
            <button type="button" class="transition-all ease-in-out delay-150 bg-size-200 bg-pos-0 hover:bg-pos-100 duration-300 text-gray-900 bg-gradient-to-r from-frcpink via-frcyellow to-frcpurple focus:ring-4 focus:ring-red-300 font-productsans font-bold rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">Get Started</button>
          </a>
          <button
            onClick={() => setburgerMenu(!burgerMenu)}
            type="button"
            class="inline-flex items-center p-2 ml-3 text-sm rounded-lg md:hidden hover:bg-gray-100focus:outline-none focus:ring-2 text-gray-400 hover:bg-gray-700 focus:ring-gray-600"
            aria-controls="mobile-menu-2"
            aria-expanded="false"
          >
            <span class="sr-only">Open main menu</span>
            <svg
              class="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <svg
              class="hidden w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
        <div class={
          burgerMenu
            ? "w-full md:block md:w-auto"
            : "hidden w-full md:block md:w-auto"
        }>
          <ul class="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-4xl md:font-medium">
            <li>
              <a href="/" class="block py-2 pr-4 pl-3 font-scoutcond font-black italic border-b md:border-0 md:p-0 md:hover:text-white text-gray-400 hover:bg-gray-700 hover:text-white md:hover:bg-transparent border-gray-700">HOME</a>
            </li>
            <li>
              <a href="/learn" class="block py-2 pr-4 pl-3 font-scoutcond font-black italic border-b md:border-0 md:p-0 md:hover:text-white text-gray-400 hover:bg-gray-700 hover:text-white md:hover:bg-transparent border-gray-700">LEARN</a>
            </li>
            <li>
              <a href="/check" class="block py-2 pr-4 pl-3 font-scoutcond font-black italic bg-frcpink rounded md:bg-transparent md:text-frcpink md:p-0 text-white" aria-current="page">CHECK</a>
            </li>
            <li>
              <a href="/discuss" class="block py-2 pr-4 pl-3 font-scoutcond font-black italic border-b md:border-0 md:p-0 md:hover:text-white text-gray-400 hover:bg-gray-700 hover:text-white md:hover:bg-transparent border-gray-700">DISCUSS</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}